<div class="assets-page">
  <header>
    <div>
      <h1>Assets</h1>
      <p>
        Manage Furniture, Hardware Assets, Softwares, and Stationary with subcategories.
        Hardware devices (Laptops, Computer, Mobile Devices) capture system configuration and IMEI.
      </p>
      @if (issueSummary(); as s) {
        <div class="issue-summary">
          <div class="stat">
            <div class="label">Issued</div>
            <div class="value">{{ s.issuedCount }}</div>
          </div>
          <div class="stat">
            <div class="label">Replacements</div>
            <div class="value">{{ s.replacementCount }}</div>
          </div>
          <div class="stat">
            <div class="label">Faulty</div>
            <div class="value">{{ s.faultyCount }}</div>
          </div>
        </div>
      }
    </div>
    @if (loading()) {
      <mat-spinner diameter="28"></mat-spinner>
    }
  </header>

  @if (error()) {
    <div class="error-banner">{{ error() }}</div>
  }
  @if (info()) {
    <div class="info-banner">{{ info() }}</div>
  }

  <mat-tab-group>
    <mat-tab label="Assets">
      <div class="tab-grid">
        <mat-card class="form-card">
          <h3>{{ editingId ? 'Edit asset' : 'Add asset' }}</h3>

          <mat-form-field appearance="outline" class="full">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="formName" placeholder="Dell Latitude 5540" />
          </mat-form-field>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Category</mat-label>
              <mat-select [(ngModel)]="formCategoryId" (ngModelChange)="onCategoryChanged()">
                @for (c of categories(); track c.id) {
                  <mat-option [value]="c.id">{{ c.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Subcategory</mat-label>
              <mat-select [(ngModel)]="formSubCategoryId">
                @for (s of selectedCategory()?.subCategories || []; track s.id) {
                  <mat-option [value]="s.id">{{ s.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Asset tag</mat-label>
              <input matInput [(ngModel)]="formAssetTag" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Serial number</mat-label>
              <input matInput [(ngModel)]="formSerialNumber" />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Manufacturer</mat-label>
              <input matInput [(ngModel)]="formManufacturer" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Model</mat-label>
              <input matInput [(ngModel)]="formModel" />
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Purchasing amount</mat-label>
              <input matInput type="number" [(ngModel)]="formPurchasePrice" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Purchase date</mat-label>
              <input matInput type="date" [(ngModel)]="formPurchaseDate" />
            </mat-form-field>
          </div>

          @if (showDeviceFields()) {
            <div class="device-box">
              <h4>Device details</h4>
              <p class="hint">Required for Laptops, Computer, and Mobile Devices.</p>
              <mat-form-field appearance="outline" class="full">
                <mat-label>System configuration</mat-label>
                <textarea
                  matInput
                  rows="3"
                  [(ngModel)]="formSystemConfiguration"
                  placeholder="CPU, RAM, Storage, OS, etc."
                ></textarea>
              </mat-form-field>
              <mat-form-field appearance="outline" class="full">
                <mat-label>IMEI number</mat-label>
                <input matInput [(ngModel)]="formImeiNumber" placeholder="15-digit IMEI" />
              </mat-form-field>
            </div>
          }

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="formStatus">
                <mat-option [value]="0">Available</mat-option>
                <mat-option [value]="1">Assigned</mat-option>
                <mat-option [value]="2">In Maintenance</mat-option>
                <mat-option [value]="3">Retired</mat-option>
                <mat-option [value]="4">Lost</mat-option>
                <mat-option [value]="5">Disposed</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Condition</mat-label>
              <mat-select [(ngModel)]="formCondition">
                <mat-option [value]="0">New</mat-option>
                <mat-option [value]="1">Good</mat-option>
                <mat-option [value]="2">Fair</mat-option>
                <mat-option [value]="3">Poor</mat-option>
                <mat-option [value]="4">Damaged</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>Warranty expiry</mat-label>
              <input matInput type="date" [(ngModel)]="formWarrantyExpiry" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Location</mat-label>
              <input matInput [(ngModel)]="formLocation" />
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" class="full">
            <mat-label>Notes</mat-label>
            <textarea matInput rows="2" [(ngModel)]="formNotes"></textarea>
          </mat-form-field>

          @if (editingId) {
            <div class="issue-box">
              <h4>Issued to / Replacement / Faulty</h4>
              <p class="hint">Choose issue type, enter EmployeeId (GUID), and set issue date.</p>

              <div class="row">
                <mat-form-field appearance="outline">
                  <mat-label>Issued to (EmployeeId GUID)</mat-label>
                  <input matInput [(ngModel)]="issueEmployeeId" placeholder="e.g. 11111111-2222-3333-4444-555555555555" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Issue date</mat-label>
                  <input matInput type="date" [(ngModel)]="issueDate" />
                </mat-form-field>
              </div>

              <mat-form-field appearance="outline" class="full">
                <mat-label>Type</mat-label>
                <mat-select [(ngModel)]="issueType">
                  <mat-option [value]="0">Issued</mat-option>
                  <mat-option [value]="1">Replacement / Changed</mat-option>
                  <mat-option [value]="2">Faulty</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full">
                <mat-label>Issue notes</mat-label>
                <textarea matInput rows="2" [(ngModel)]="issueNotes"></textarea>
              </mat-form-field>

              <div class="form-actions">
                <button mat-flat-button color="accent" type="button" (click)="issueAsset()">
                  <mat-icon>assignment_turned_in</mat-icon>
                  Save issue
                </button>
              </div>
            </div>
          }

          <div class="form-actions">
            <button mat-flat-button color="primary" type="button" (click)="saveAsset()">
              <mat-icon>{{ editingId ? 'save' : 'add' }}</mat-icon>
              {{ editingId ? 'Update asset' : 'Save asset' }}
            </button>
            @if (editingId) {
              <button mat-stroked-button type="button" (click)="resetForm()">Cancel</button>
            }
          </div>
        </mat-card>

        <mat-card class="table-card">
          <div class="table-head">
            <h3>Asset list</h3>
            <div class="filters">
              <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Category</mat-label>
                <mat-select [(ngModel)]="filterCategoryId" (ngModelChange)="onFilterCategoryChanged()">
                  <mat-option value="">All</mat-option>
                  @for (c of categories(); track c.id) {
                    <mat-option [value]="c.id">{{ c.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Subcategory</mat-label>
                <mat-select [(ngModel)]="filterSubCategoryId" (selectionChange)="loadAssets()">
                  <mat-option value="">All</mat-option>
                  @for (s of filteredSubCategories(); track s.id) {
                    <mat-option [value]="s.id">{{ s.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="filter-search">
                <mat-label>Search</mat-label>
                <input matInput [(ngModel)]="search" (keyup.enter)="loadAssets()" />
              </mat-form-field>
              <button mat-stroked-button type="button" (click)="loadAssets()">
                <mat-icon>search</mat-icon>
                Filter
              </button>
            </div>
          </div>

          <table mat-table [dataSource]="assets()" class="full">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let row">{{ row.name }}</td>
            </ng-container>
            <ng-container matColumnDef="category">
              <th mat-header-cell *matHeaderCellDef>Category</th>
              <td mat-cell *matCellDef="let row">{{ row.category }}</td>
            </ng-container>
            <ng-container matColumnDef="subCategory">
              <th mat-header-cell *matHeaderCellDef>Subcategory</th>
              <td mat-cell *matCellDef="let row">{{ row.subCategory || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="tag">
              <th mat-header-cell *matHeaderCellDef>Tag</th>
              <td mat-cell *matCellDef="let row">{{ row.assetTag || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="imei">
              <th mat-header-cell *matHeaderCellDef>IMEI</th>
              <td mat-cell *matCellDef="let row">{{ row.imeiNumber || '—' }}</td>
            </ng-container>
            <ng-container matColumnDef="purchasePrice">
              <th mat-header-cell *matHeaderCellDef>Purchase</th>
              <td mat-cell *matCellDef="let row">{{ money(row.purchasePrice) }}</td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status</th>
              <td mat-cell *matCellDef="let row">{{ statusLabel(row.status) }}</td>
            </ng-container>
            <ng-container matColumnDef="device">
              <th mat-header-cell *matHeaderCellDef>Device</th>
              <td mat-cell *matCellDef="let row">
                @if (row.systemConfiguration) {
                  <div class="device-cell">
                    @if (row.systemConfiguration) {
                      <small class="cfg">{{ row.systemConfiguration }}</small>
                    }
                  </div>
                } @else {
                  —
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button type="button" (click)="editAsset(row)" aria-label="Edit">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button type="button" (click)="deleteAsset(row)" aria-label="Delete">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="assetColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: assetColumns"></tr>
          </table>
          @if (!assets().length) {
            <p class="empty">No assets yet.</p>
          }
        </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Categories">
      <div class="tab-grid categories-grid">
        <mat-card class="form-card">
          <h3>Add category</h3>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Category name</mat-label>
            <input matInput [(ngModel)]="newCategoryName" (keyup.enter)="createCategory()" />
          </mat-form-field>
          <button mat-flat-button color="primary" type="button" (click)="createCategory()">
            <mat-icon>playlist_add</mat-icon>
            Add category
          </button>

          <h3 class="mt">Add subcategory</h3>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Parent category</mat-label>
            <mat-select [(ngModel)]="manageCategoryId">
              @for (c of categories(); track c.id) {
                <mat-option [value]="c.id">{{ c.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full">
            <mat-label>Subcategory name</mat-label>
            <input matInput [(ngModel)]="newSubCategoryName" (keyup.enter)="createSubCategory()" />
          </mat-form-field>
          <button mat-flat-button color="accent" type="button" (click)="createSubCategory()">
            <mat-icon>subdirectory_arrow_right</mat-icon>
            Add subcategory
          </button>
        </mat-card>

        <mat-card class="table-card">
          <h3>Category tree</h3>
          @for (cat of categories(); track cat.id) {
            <div class="cat-block">
              <div class="cat-row">
                <strong>{{ cat.name }}</strong>
                <span class="badge" [class.default]="cat.isDefault">{{ cat.isDefault ? 'Default' : 'Custom' }}</span>
                <button mat-icon-button type="button" color="warn" (click)="deleteCategory(cat)" aria-label="Delete category">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <ul>
                @for (sub of cat.subCategories; track sub.id) {
                  <li>
                    <span>
                      {{ sub.name }}
                      @if (sub.requiresDeviceDetails) {
                        <em class="device-flag">device details</em>
                      }
                    </span>
                    <button mat-icon-button type="button" (click)="deleteSubCategory(sub)" aria-label="Delete subcategory">
                      <mat-icon>close</mat-icon>
                    </button>
                  </li>
                }
              </ul>
            </div>
          }
          @if (!categories().length) {
            <p class="empty">No categories yet.</p>
          }
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
